import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/box/box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/center/center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/icon/icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/list/list.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["HStack"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["createContext"] */ "/vercel/path0/node_modules/@chakra-ui/utils/dist/esm/context.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/elastic.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-elastic.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/accordionList/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/cardsList/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/certificates/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contactForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/features/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/heroCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/intro/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/logoBox/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ourCustomers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/technologyPartners/index.tsx");
